export function reverse(str: string) {
  return str.split('').reverse().join('');
}
